import { render } from "./TraitementReclamationPage.vue?vue&type=template&id=4152420a&ts=true"
import script from "./TraitementReclamationPage.vue?vue&type=script&lang=ts"
export * from "./TraitementReclamationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__